import ProjectsNumberDescComponentId from './ProjectsNumberDescComponentId';
export default class ProjectsNumberDescComponent {
    constructor(projects) {
        const { projects_number_desc_component_id } = projects;
        this.projects_number_desc_component_id = projects_number_desc_component_id
            ? new ProjectsNumberDescComponentId(projects_number_desc_component_id)
            : undefined;
    }
}
